import React from 'react'
import type { CompaniesReducerState } from '../../types'
import { MAX_SELECTED_CHILDREN } from '../../constants'
import { areSelectionsEqual } from '../../helpers/selection'

const useSelectionDerivedState = (params: {
  state: CompaniesReducerState
  parentChildrenCount: number
  isUsingRemoteChildren: boolean
  selectionLimit: number
}) => {
  const { state, parentChildrenCount, isUsingRemoteChildren, selectionLimit } = params
  const {
    pendingSelection,
    selectedChildren,
    isAllAccountsSelected,
    isOrphanSelected,
    pendingAllAccountsSelection,
  } = state

  const pendingSelectionIsAllAccounts =
    pendingAllAccountsSelection && Boolean(pendingSelection.length)

  const hasPendingSelection = React.useMemo(
    () =>
      !areSelectionsEqual(selectedChildren, pendingSelection) ||
      isAllAccountsSelected !== pendingSelectionIsAllAccounts,
    [isAllAccountsSelected, pendingSelection, pendingSelectionIsAllAccounts, selectedChildren],
  )

  const canSelectAllChildren =
    !isOrphanSelected &&
    !isUsingRemoteChildren &&
    parentChildrenCount > 0 &&
    parentChildrenCount <= MAX_SELECTED_CHILDREN

  const pendingSelectionLimitReached =
    pendingSelection.length >= selectionLimit && !pendingSelectionIsAllAccounts

  return {
    pendingSelectionIsAllAccounts,
    hasPendingSelection,
    canSelectAllChildren,
    pendingSelectionLimitReached,
  }
}

export { useSelectionDerivedState }
